import { useSystemProvider } from "src/system/SystemProvider.tsx";

export const useDataProvider = () => {
  const context = useSystemProvider();
  return context.dataProvider;
};
